import { adminApiFetch } from './apiService';

export const shelfService = {
  // 列表 (分頁/表格)
  getRecords: async (params) => {
    const response = await adminApiFetch('shelves/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await adminApiFetch('shelves/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 列表 (GET)
  fetchList: async (params = {}) => {
    const response = await adminApiFetch('shelves', { method: 'GET' });
    return response.json();
  },

  // 獲取單個
  get: async (id) => {
    const response = await adminApiFetch(`shelves/${id}`);
    return response.json();
  },

  // 獲取貨架庫存
  getInventories: async (params) => {
    const response = await adminApiFetch('inventory_shelves/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 全選 ID (庫存)
  getInventoryIds: async (params) => {
    const response = await adminApiFetch('inventory_shelves/get_ids', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 獲取 merchants 列表
  getMerchants: async () => {
    const response = await adminApiFetch('merchants', {
      method: 'GET'
    });
    return response.json();
  }
};
export default shelfService;
